export default {
  getIsLoading: (state) => {
    return state.isLoading;
  },
  getIsForceLoading: (state) => {
    return state.isForceLoading;
  },
  getIsOn: (state) => {
    return state.isOn;
  },
  getIsFocus: (state) => {
    return state.isFocus;
  },
  getModalAlertComponents: (state) => {
    return state.modalAlertComponents;
  },
  getModalComponents: (state) => {
    return state.modalComponents;
  },
  getToast: (state) => {
    return state.toast;
  },
  getRouteLayout: (state) => {
    return state.routeLayout;
  },
  getKeywords(state) {
    state.keywords = JSON.parse(localStorage.getItem('keywords')) || [];
    return state.keywords;
  },
  keepAliveList(state) {
    return state.keepAlive;
  },
  getScrollTop(state) {
    return state.scrollTop;
  },
  getFromStorePath(state) {
    return state.fromStorePath;
  }
};
